import { createRoot } from 'react-dom/client'

import '@factorialco/deprecated-design-system/dist/style.css'
import '@factorialco/f0-react/dist/styles.css'
import * as Sentry from '@sentry/browser'
import { EnvironmentContext, fetchEnvironment } from 'config/environment'
import { GetCurrentDocument } from 'generated/resources/graphql'
import { sessionExpired } from 'initializers/axiosInterceptors'
import moment from 'moment'

import SentryErrorBoundary from 'modules/core/components/Bootstrap/SentryErrorBoundary'
import CrashLogo from 'modules/core/components/CrashLogo'
import { SessionProvider } from 'modules/core/components/SessionProvider'
import { dateToString } from 'modules/core/lib/dates'
import { buildClient } from 'modules/core/lib/graphql/buildClient'
import { GraphQLProvider } from 'modules/core/lib/graphql/provider'
import { NavigationProvider } from 'modules/core/lib/navigation/provider'
import { ApplicationRoutes } from 'modules/core/routes/application'

import './styles/main.css'
import { dataInitializers, initializers } from './initializers'
import { UnsupportedBrowser, browserSupported } from './modules/core/components/UnsupportedBrowser'
import './polyfills'

const main = async () => {
  const container = document.getElementById('factorialRoot')

  if (!container) throw Error('No "factorialRoot" element has been found')

  const root = createRoot(container)

  if (!browserSupported()) {
    return root.render(<UnsupportedBrowser />)
  }

  try {
    const environment = await fetchEnvironment()
    initializers.forEach((initializer) => initializer(environment))

    const graphQLClient = await buildClient(environment)

    // TODO: this can be deprecated in favor of `errorLink` in buildClient function
    try {
      await graphQLClient.query({
        query: GetCurrentDocument,
        variables: {
          contractVersionsActiveOn: dateToString(moment(), 'backend'),
        },
      })
    } catch {
      sessionExpired(environment)
    }

    dataInitializers.forEach((initializer) => initializer(environment, graphQLClient))

    root.render(
      <SentryErrorBoundary>
        <EnvironmentContext.Provider value={environment}>
          <GraphQLProvider client={graphQLClient}>
            <SessionProvider>
              <NavigationProvider>
                <ApplicationRoutes />
              </NavigationProvider>
            </SessionProvider>
          </GraphQLProvider>
        </EnvironmentContext.Provider>
      </SentryErrorBoundary>
    )
  } catch (error) {
    console.error(error) // eslint-disable-line no-console
    Sentry.captureException(error)

    root.render(<CrashLogo isBootstrap />)
  }
}

main()
